import React from "react";
import "./styles.css";
import { SharingPaused, AjjasLogo } from "../../../Assets/images/svgs";

const SharingStopped = () => {
  return (
    <div className="sp-cnt">
      <div className="sp-header">
        <AjjasLogo className="sp-logo" />
        <span className="sp-title">
          Creating a future where every vehicle is SMART & every driver is SAFE
        </span>
      </div>
      <div className="sp-body">
        <SharingPaused className="sp-inf-logo" />
        <span className="sp-inf">
          Vehicle owner has stopped sharing their details. If you want to still
          reach out to them, you can contact Ajjas customer support
        </span>
      </div>
    </div>
  );
};

export default SharingStopped;
